'use client';

import Image from 'next/image';
import Container from '@/components/container';
import { useProductListTotalItems } from '@/features/products/state/list/context';
import { listingTranslate } from '@/i18n/translations/listingTranslations';

interface SearchQueryHeaderProps {
  query: string;
  totalItems: number;
}

export const SearchQueryHeader = ({ query, totalItems }: SearchQueryHeaderProps) => {
  const totalItemsSelector = useProductListTotalItems();
  if (!query) return null;

  return (
    <div className="flex justify-center rounded-lg sm:rounded-none bg-(--mui-palette-quinary-lighter)">
      <Container className="!p-4 md:!py-6 flex justify-between items-center">
        <div className="flex flex-col">
          <h1 className="font-normal text-2xl md:text-3xl leading-[124%] font-['Gilda_Display'] text-(--mui-palette-text-primary)">
            {listingTranslate('product-query1')}
            <br className="md:hidden" />
            {listingTranslate('product-query2')}
            <span className="text-(--mui-palette-secondary-main)"> “{query}”</span>
          </h1>
          <p className="text-xs mt-1 mb-0 self-start lowercase text-(--mui-palette-text-disabled)">
            {`(${listingTranslate('product-count')} ${totalItemsSelector || totalItems})`}
          </p>
        </div>
        <div className="size-14 md:size-24 lg:w-28 lg:h-24 md:-mt-3 lg:-mt-6 relative self-start shrink-0">
          <Image
            alt="ikona prezentu"
            src="/gift.png"
            fill
            sizes="(max-width: 768px) 56px, (max-width: 1024px) 96px, 112px"
            className="size-full object-contain"
            loading="lazy"
          />
        </div>
      </Container>
    </div>
  );
};
